export function DestinationMessagingConsentScreenshot() {
    return (
      <section className="flex min-h-full flex-1 flex-col justify-start px-6 py-6 lg:px-8">
          <img src="/images/destination-messaging-consent-screenshot.png" />
      </section>
    );
}
